<template>
  <div class="d-flex align-items-start">
    <multiselect
      :id="inputId"
      v-model="selected"
      :options="filteredOptions"
      :custom-label="countryOptionLabel"
      track-by="value"
      :multiple="false"
      :internal-search="false"
      :loading="false"
      :placeholder="placeholder"
      :allow-empty="true"
      :clearable="false"
      :preserve-search="true"
      class="flex-grow-1"
      @search-change="onSearchChange"
      @input="onInput"
    />
    <b-button
      v-if="selected"
      variant="light"
      size="sm"
      class="ml-1 clear-btn"
      @click="clearSelection"
    >
      <i class="fas fa-times"></i>
    </b-button>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { countryOptionLabel, findCountryByCode, searchCountries } from "./countryOptions";

export default {
  name: "CountryCodeSelect",
  components: { Multiselect },
  props: {
    value: { type: String, default: '' },
    inputId: { type: String, default: 'country-code-select' },
    placeholder: { type: String, default: 'Search by code or country name' },
  },
  data() {
    return {
      selected: null,
      searchQuery: '',
    };
  },
  computed: {
    filteredOptions() {
      return searchCountries(this.searchQuery);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(code) {
        const normalized = (code || '').trim().toUpperCase();
        if (!normalized) {
          this.selected = null;
          return;
        }
        if (this.selected?.value === normalized) return;
        this.selected = findCountryByCode(normalized) || { value: normalized, label: normalized };
      },
    },
  },
  methods: {
    countryOptionLabel,
    onSearchChange(query) {
      this.searchQuery = query;
    },
    onInput(option) {
      this.$emit('input', option?.value || '');
    },
    clearSelection() {
      this.selected = null;
      this.searchQuery = '';
      this.$emit('input', '');
    },
  },
};
</script>

<style scoped>
.clear-btn {
  margin-top: 2px;
}
</style>
